import React from "react";
import { Link } from "react-router-dom";
import { PRODUCTS } from "../context/CartContext";
import jarHara from "../assets/jar-hara.webp";
import jarTurmeric from "../assets/jar-turmeric.webp";
import jarHoney from "../assets/jar-honey.webp";
import "./ProductScroll.css";

var IMAGES = {
  "hara-namak": jarHara,
  turmeric: jarTurmeric,
  honey: jarHoney,
  "hemp-salt": jarHara,
  "flax-salt": jarHara,
};

export default function ProductScroll() {
  var products = Object.values(PRODUCTS).filter(function (p) { return p.id !== "test-1"; });

  return (
    <section className="product-scroll-section">
      <div className="product-scroll-header">
        <span className="section-label">Shop the Range</span>
        <h2>Explore Our Jars</h2>
      </div>
      <div className="product-scroll-track">
        {products.map(function (p) {
          return (
            <Link to={"/products"} key={p.id} className="product-scroll-item">
              <div className="product-scroll-circle">
                <img src={IMAGES[p.id]} alt={p.name} />
              </div>
              <span className="product-scroll-name">{p.name}</span>
              <span className="product-scroll-price">{"\u20B9" + p.price}</span>
            </Link>
          );
        })}
        <Link to="/products" className="product-scroll-item product-scroll-viewall">
          <div className="product-scroll-circle product-scroll-viewall-circle">
            <span>&#8594;</span>
          </div>
          <span className="product-scroll-name">View All</span>
        </Link>
      </div>
    </section>
  );
}
